var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelivered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 17.442V42.558C60 53.481 53.478 60 42.558 60H17.442C6.522 60 0 53.481 0 42.558V17.442C0 6.519 6.522 0 17.442 0H42.558C53.478 0 60 6.519 60 17.442Z",
    fill: "url(#paint0_linear_717_4780)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3346 39.5C29.8346 39.5 29.5013 39.3333 29.168 39L22.168 32C21.5013 31.3333 21.5013 30.3333 22.168 29.6667C22.8346 29 23.8346 29 24.5013 29.6667L30.3346 35.5L43.3346 22.5C44.0013 21.8333 45.0013 21.8333 45.668 22.5C46.3346 23.1667 46.3346 24.1667 45.668 24.8333L31.5013 39C31.3346 39.3333 30.8346 39.5 30.3346 39.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9987 39.5C21.4987 39.5 21.1654 39.3333 20.832 39L13.832 32C13.1654 31.3333 13.1654 30.3333 13.832 29.6667C14.4987 29 15.4987 29 16.1654 29.6667L23.1654 36.6667C23.832 37.3333 23.832 38.3333 23.1654 39C22.9987 39.3333 22.4987 39.5 21.9987 39.5ZM30.832 30.8333C30.332 30.8333 29.9987 30.6667 29.6654 30.3333C28.9987 29.6667 28.9987 28.6667 29.6654 28L34.9987 22.5C35.6654 21.8333 36.6654 21.8333 37.332 22.5C37.9987 23.1667 37.9987 24.1667 37.332 24.8333L31.9987 30.3333C31.6654 30.6667 31.332 30.8333 30.832 30.8333Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_717_4780",
    x1: 11.6334,
    y1: 61.3986,
    x2: 56.7391,
    y2: -3.91305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0105699,
    stopColor: "#A80BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#557EE9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivered);
export default __webpack_public_path__ + "static/media/delivered.3c7f4a8d3d97d1860053600161ef787b.svg";
export { ForwardRef as ReactComponent };